import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export default function BlogCard({ post }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="overflow-hidden bg-white rounded-xl border shadow-sm border-emerald-600/20"
    >
      <Link to={`/blog/${post.id}`} className="block">
        <div className="relative aspect-[16/10] w-full overflow-hidden">
          <img src={post.image} alt={post.title} className="object-cover w-full h-full" />
        </div>
      </Link>
      <div className="p-4">
        <div className="flex items-center gap-2 text-[11px] text-emerald-700">
          <span>{post.date}</span>
          <span className="w-1 h-1 bg-emerald-600 rounded-full" />
          <span className="inline-flex gap-1 items-center">
            <Clock size={12} />
            {post.minutes} min read
          </span>
        </div>
        <Link to={`/blog/${post.id}`} className="block mt-2 text-sm font-semibold text-gray-900 line-clamp-2 hover:underline">
          {post.title}
        </Link>
        <p className="mt-2 text-xs text-gray-600 line-clamp-3">{post.excerpt}</p>
      </div>
    </motion.article>
  );
}


